import React from "react";
import CelebrationStats from "./component/celebrations.stats";
import CelebrationTabs from "./component/celebrations.tabs";
import {eventDataType} from "./type/celebrations.types";
import PageHeader from "../common/page-header/page-header";
import '../../styles/component/celebrations/celebrations.scss';

export interface CelebrationTabsProps {
    newBirthdayData: eventDataType;
    newAnniversaryData: eventDataType;
}

const CelebrationsView = (props: CelebrationTabsProps) => {
    return (
        <>
            <div className={'celebrations-box'}>
                <PageHeader title={'Team Celebrations'} description={'Celebrating moments that bring us together'}/>
                <CelebrationStats newBirthdayData={props.newBirthdayData}
                                  newAnniversaryData={props.newAnniversaryData}/>
                <CelebrationTabs newBirthdayData={props.newBirthdayData}
                                 newAnniversaryData={props.newAnniversaryData}/>
            </div>

        </>
    );
};

export default CelebrationsView;
